import type { DonationAlertEvent } from '@shared/types'

import { type EffectPlugin } from '@shared/lib/effect-registry'

import { DonationAlert } from '../DonationAlert'

export const donationAlertPlugin: EffectPlugin<DonationAlertEvent> = {
  type: 'donation_alert',
  component: DonationAlert,
  sound: {
    src: '/sounds/donation.mp3',
    volume: 1.0,
    delayMs: 0,
  },
}
